<template>
  <div class="downloadApp">
    <div class="toBack" @click="goback()">
      <img src="./images/ico_next_l@2x.png" width="25" alt="">
      <span>返回</span>
    </div>
    <div class="tips">
      <span>该课程仅支持app以及客户端查看，请选择下方观看方式扫码进行下载观看</span>
    </div>
    <div class="download_tips">
      <!-- <span>请扫描下方二维码下载</span> -->
    </div>
    <div class="ewm_box">
      <div>
        <div class="ewm">
          <img class="yel" src="./images/anzhuo.png" alt="">
          <img class="row" src="./images/An1.png" alt="">
        </div>
        <span style="margin-top: 32px;font-size: 24px;">安卓下载链接</span>
      </div>
      <div>
        <div class="ewm">
          <img class="yel" src="./images/anzhuo.png" alt="">
          <img class="row" src="./images/An2.png" alt="">
        </div>
        <span style="margin-top: 32px;font-size: 24px;">安卓备用链接</span>
      </div>
      <div>
        <div class="ewm">
          <img class="yel" src="./images/iostp.png" alt="">
          <img class="row" src="./images/ios.png" alt="">
        </div>
        <span style="margin-top: 32px;font-size: 24px;">iOS下载链接</span>
      </div>
      <div>
        <div class="ewm">
          <img class="yel" @click="windowsIM" src="./images/windoim.png" alt="">
          <img class="row" @click="windowsIM" src="./images/xiazaiw.png" alt="">
        </div>
        <span style="margin-top: 32px;font-size: 24px;">windows 珊瑚课堂<br>学员端</span>
      </div>
      <div v-if="!isMac">
        <div class="ewm">
          <img class="yel" @click="macOSIM" src="./images/macim.png" alt="">
          <img class="row" @click="macOSIM" src="./images/xiazaiw.png" alt="">
        </div>
        <span style="margin-top: 32px;font-size: 24px;">macOS  珊瑚课堂<br>学员端</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getMiniConfig } from '@/utils/useUserConfig.js';
export default {
   name:"downloadApp",
    data(){
      return {
        isMac: false
      }
    },
    created() {
      const isProd = process.env.NODE_ENV === 'production'
      // 获取是否在后台勾选不允许Mac端登录 /macintosh|mac os x/i.test(navigator.userAgent)
      const host = isProd? 'https://live.shkt.online' : 'https://live.tenghuiketang.com'
      const uid = this.$store.state.user.org_id
      this.$axios.post(`${host}/liveapi/customer/index/qryUserConfigs`, { uid }).then(res => {
        if (res && res.data.code === 200) {
          const obj = res.data.data.find(item => item.key === 'notLoginMac')
          this.isMac = obj.value === 'true'
        }
      })

      
    },
    methods:{
      async macOSIM () {
        let mac_download_urlTmp = ''
        try {
           const resData = await getMiniConfig();
           mac_download_urlTmp = resData.data.shkt_student_mac_download_url
        } catch (error) {
           console.log(error)
        }
        if (mac_download_urlTmp) {
          window.location.href = mac_download_urlTmp
        }else{
          window.location.href = 'https://tengface-project.oss-accelerate.aliyuncs.com/im_exe/shanhu/mac/sign/%E7%8F%8A%E7%91%9A%E8%AF%BE%E5%A0%82-1.0.28.dmg';

        }
      },
      async windowsIM () {
        let wid_download_urlTmp = ''
         try {
           const resData = await getMiniConfig();
           wid_download_urlTmp = resData.data.shkt_student_win_download_url
        } catch (error) {
           console.log(error)
        }
        if (wid_download_urlTmp) {
          window.location.href = wid_download_urlTmp
        }else {
           window.location.href = 'https://tengface-project.oss-accelerate.aliyuncs.com/im_exe/shanhu/win/sign/%E7%8F%8A%E7%91%9A%E8%AF%BE%E5%A0%82%20Setup%201.6.49.exe'
        }
      },
      goback(){
        this.$router.go(-1)
      }
    }
}
</script>
<style lang="scss" scoped>
.downloadApp{
  height: 100vh;
  background: url(./images/download_bg.png) no-repeat;
  background-size: 100% 100%;
  .toBack{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 24px;
    font-size: 20px;
    cursor: pointer;
  }
  .tips{
    margin: 0 auto;
    margin-top: 100px;
    font-size: 32px;
    font-weight: 600;
    text-align: center;
    color: #202020;
  }
  .download_tips{
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    color: #666666;
    margin: 30px auto 20px;
  }
  .ewm_box{
    display: flex;
    justify-content: space-around;
    text-align: center;
    padding: 0 200px;
    .ewm{
      width: 213px;
      border-radius: 8px;
      img{
        width: 100%;
        height: 100%;
      }
      .row {display: none;}
      .yel{display: block;}
      &:hover {
        .row {display: block;}
        .yel{display: none;}
      }
    }
  }
}
</style>